import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { afterLogoutSuccess } from './permissions.actions';

@Injectable({
    providedIn: 'root'
})
export class PermissionsFacade {
    constructor(private store$: Store) {}

    logoutSuccess(): void {
        this.store$.dispatch(afterLogoutSuccess());
    }
}
